interface Props {
  title: string;
  count?: number;
  /** F17: optional anchor id для in-page навигации (#all-services из Hero CTA). */
  id?: string;
}

export default function SectionHeader({ title, count, id }: Props) {
  return (
    <div className="section-header" id={id}>
      <h2 className="section-header__title">{title}</h2>
      {typeof count === 'number' && (
        <span className="section-header__count">{count}</span>
      )}
    </div>
  );
}
